import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('../views/AboutView.vue')
  },
  {
    path: '/meet-the-team',
    name: 'meet-the-team',
    component: () => import('../views/TeamView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue')
  },
  {
    path: '/events',
    name: 'events',
    component: () => import('../views/EventsView.vue')
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/PrivacyView.vue')
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import('../views/NewsletterFeedback.vue')
  },
  {
    path: '/registerMUN',
    name: 'registerMUN',
    component: () => import('../views/registerMUN.vue')
  },
  {
    path: '/munregistration',
    name: 'MunRegistration',
    component: () => import('../views/MUNRegistration.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
